import React from "react";
import Cases from "../../Components/Cases/Cases";
import { Box } from "@chakra-ui/react";

const CasePage = () => {
  return (
    <Box>
      <Cases />
    </Box>
  );
};

export default CasePage;
